module.exports = __webpack_public_path__ + "img/c5.5f246186.png";